import microuniversoApi from "app/api/microuniversoApi";
import store from "app/redux/store/store";
import globalMU from "globalMU";
import { WindowMU } from "app/types/WindowMU"
import { IOrcamento } from "app/types/IOrcamento";
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice";


declare var window: WindowMU


export const DefinirPrecoTintaRedux = async (Identificador: number, Preco: number,orcamento:IOrcamento) => {
    const orcamentoLegado = window.orcamentoController.model
    globalMU.blockUI();

    const orcamentoAtualizado = await microuniversoApi.Orcamento.DefinirPrecoTinta(orcamento.IdentificadorOrcamento, Identificador, Preco.toString().replace('.', ','));
    globalMU.unblockUI();
    store.dispatch(sobrescreverInformacoesAction({ ...orcamento, ...orcamentoAtualizado }));
    orcamentoLegado.atualizar({ ...orcamentoAtualizado } as IOrcamento, true, true);
}


